export const WINDOW_PACKAGE_SEGMENT_SEQUENCE_START = 100; // Generic starting sequence for segment.PRICE.

export const isJacadaWiggleRoom = segment => segment.TourplanCode === 'CYMDMJAC021OVER01'; // JAC021
//export const isJacadaWiggleRoom = segment => segment.BookingLineDescription === "DMC override pricing line for Wiggle room";
// YZ wiggleRoom is coming, will be able to craft a good truthy function.
